import { Reveal, Overline } from "@/components/Reveal";

const RISKS = [
  {
    stat: "$150k – $2M",
    label: "Inversión inicial típica",
    desc: "Renta, remodelación, equipamiento e inventario antes de facturar el primer peso.",
  },
  {
    stat: "24 – 48 meses",
    label: "Tiempo de retorno promedio",
    desc: "Años atado a un contrato de renta mientras recupera la inversión del local.",
  },
  {
    stat: "~30%",
    label: "Cierran en los primeros años",
    desc: "El punto de venta físico concentra el costo fijo y el riesgo operativo.",
  },
];

export function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-6">
            <Reveal>
              <Overline>El problema</Overline>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
                Una franquicia tradicional le vende un{" "}
                <span className="text-crimson">costo fijo</span>, no un negocio.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.15}>
              <p className="font-sans text-lg font-light leading-relaxed text-midnight/60">
                El modelo de comida o retail concentra todo el riesgo en un solo punto físico:
                el metro cuadrado. Usted paga renta esté o no vendiendo, contrata personal en piso
                y compra inventario que se deprecia. Antes de facturar, ya perdió.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-midnight/10 mt-20 border border-midnight/10">
          {RISKS.map((r, i) => (
            <Reveal key={r.label} delay={i * 0.1} className="bg-white">
              <div className="p-8 lg:p-10 h-full">
                <div className="font-serif text-4xl lg:text-5xl font-black text-crimson tracking-tighter">{r.stat}</div>
                <div className="font-sans text-sm uppercase tracking-wider text-midnight mt-4 font-semibold">{r.label}</div>
                <p className="font-sans text-base font-light text-midnight/60 mt-4 leading-relaxed">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
